module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_09-799f44906ab44e90c0ccca55169cac3b.png";